import { useState } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { motion } from "framer-motion";

const HealthGoals = () => {
  const [goals, setGoals] = useState([
    { id: "1", name: "Daily Steps", current: 7500, target: 10000 },
    { id: "2", name: "Water Intake", current: 6, target: 8 },
    { id: "3", name: "Sleep Hours", current: 7, target: 8 },
  ]);

  return (
    <Card className={""}>
      <CardHeader className={""}>
        <CardTitle className={""}>Health Goals</CardTitle>
      </CardHeader>
      <CardContent>
        {goals?.map((goal) => (
          <motion.div
            key={goal.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-4"
          >
            <div className="flex justify-between mb-2">
              <span>{goal.name}</span>
              <span>
                {goal.current} / {goal.target}
              </span>
            </div>
            <Progress value={(goal.current / goal.target) * 100} />
          </motion.div>
        ))}
        <Button className="w-full mt-4">
          <Plus className="mr-2 h-4 w-4" /> Add New Goal
        </Button>
      </CardContent>
    </Card>
  );
};

export default HealthGoals;
